import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
import { getScaledResolvedImageUri, ImageScale } from "@/helpers/image.helpers";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { useGatewayImageLoadState } from "@/components/common/image/useGatewayImageLoadState";
interface NotificationHeaderProps {
  readonly author: ApiProfileMin;
  readonly children: React.ReactNode; // Content AFTER the user link (e.g. "replied • 2h")
  readonly actions?: React.ReactNode | undefined; // Follow button(s)
  readonly authorClassName?: string | undefined;
}
export default function NotificationHeader(t0) {
  const $ = _c(24);
  const {
    author,
    children,
    actions,
    authorClassName: t1
  } = t0;
  const authorClassName = t1 === undefined ? "tw-text-sm" : t1;
  const {
    activeSrc,
    isPlaceholder,
    unoptimized,
    handleError
  } = useGatewayImageLoadState(author.pfp);
  let t2;
  if ($[0] !== activeSrc || $[1] !== author.handle || $[2] !== handleError || $[3] !== isPlaceholder || $[4] !== unoptimized) {
    t2 = <div className="tw-relative tw-h-7 tw-w-7 tw-flex-shrink-0">{!isPlaceholder && activeSrc ? <Image key={`${activeSrc}-${unoptimized ? "unoptimized" : "optimized"}`} src={getScaledResolvedImageUri(activeSrc, ImageScale.W_AUTO_H_50)} alt={author.handle ?? "User profile"} fill={true} sizes="28px" unoptimized={unoptimized} onError={handleError} className="tw-flex-shrink-0 tw-rounded-md tw-bg-iron-800 tw-object-contain tw-ring-1 tw-ring-iron-700" /> : <div className="tw-h-full tw-w-full tw-flex-shrink-0 tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[0] = activeSrc;
    $[1] = author.handle;
    $[2] = handleError;
    $[3] = isPlaceholder;
    $[4] = unoptimized;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = author.handle ?? "";
  const t4 = `/${author.handle}`;
  const t5 = `${authorClassName} tw-font-semibold tw-text-iron-50 tw-no-underline`;
  let t6;
  if ($[6] !== author.handle || $[7] !== t4 || $[8] !== t5) {
    t6 = <Link href={t4} className={t5}>{author.handle}</Link>;
    $[6] = author.handle;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <UserProfileTooltipWrapper user={t3}>{t6}</UserProfileTooltipWrapper>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== children || $[14] !== t7) {
    t8 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-1">{t7}{children}</div>;
    $[13] = children;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== actions) {
    t9 = actions && <div className="tw-flex-shrink-0">{actions}</div>;
    $[16] = actions;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-items-start tw-gap-y-2 min-[390px]:tw-flex-row min-[390px]:tw-items-center min-[390px]:tw-justify-between min-[390px]:tw-gap-x-2">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2) {
    t11 = <div className="tw-flex tw-items-start tw-gap-x-3">{t2}{t10}</div>;
    $[21] = t10;
    $[22] = t2;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}